import React, { useContext, useState, Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { VscKebabVertical } from 'react-icons/vsc';
import { UserContext } from '../App';
import defaultAvatar from '../images/default.png';
const FollowModal = lazy(() => import('./modal/FollowModal'));
export default function ProfileDetails(props) {
  const user = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const account = `/account?ud=${encodeURIComponent(props.user_id || props.email || '')}`;
  const avatar = props.profile_picture_link && props.profile_picture_link !== '1' ? props.profile_picture_link : defaultAvatar;
  return <div className="profile">
    <Link to={account} aria-label={`View ${props.userName || 'creator'} profile`}><div className="profile-photo"><img src={avatar} alt="" loading="lazy" decoding="async" onError={event => { event.currentTarget.onerror = null; event.currentTarget.src = defaultAvatar; }} /></div></Link>
    <Link to={account}><div className="username"><h5>{props.userName || 'Community member'}</h5></div></Link>
    {user && <button className="kebab-menu" aria-label="More creator options" onClick={() => setOpen(true)}><VscKebabVertical /></button>}
    {open && user && <Suspense fallback={null}><FollowModal closeFollowModal={setOpen} email={props.email} /></Suspense>}
  </div>;
}
